// extracted by mini-css-extract-plugin
export default {"options-wrapper":"style_options-wrapper__43+nD","initChatBox":"style_initChatBox__ylhb-","sceneAvatar":"style_sceneAvatar__FMED1"};